import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const TableauUserFragmentGql: DocumentNode = gql`
fragment TableauUserFragment on TableauUser {
  username
  name
  domain
}
`;
